
<div v-if="!isLoading" class="EntityDetailsCashJournalTransactions">
    <BaseDashboardTable
        :columns="columns"
        :items="formattedTransactions"
        :empty-message="'Keine Transaktionen für diesen Monat gefunden'"
        :pagination="{ enabled: false }"
        container-height="400px"
        :has-search="true"
        search-placeholder="Transaktionen suchen..."
    >
        <template #column-type="{ item }">
            <Badge :color-id="getBadgeColorId(item.type)" size="small">
                {{ item.typeLabel }}
            </Badge>
        </template>

        <template #column-amount="{ item }">
            <span :class="item.amount >= 0 ? 'amount-positive' : 'amount-negative'">
                {{ item.formattedAmount }}
            </span>
        </template>

        <template #column-timestamp="{ item }">
            {{ item.formattedDate }}
        </template>
    </BaseDashboardTable>
</div>
